import type { FilterComponentState } from '@/types/filters'
import { FilterTypeEnum } from '@/types/filters'
import { FilterTimeRangeTypesEnum, SortRuleEnum } from '@/types/product'

export const DEFAULT_FILTER_STATE: FilterComponentState = {
  [FilterTypeEnum.SORTBY]: SortRuleEnum.POPULAR,
  [FilterTypeEnum.NOW]: 0,
  [FilterTypeEnum.DATE]: null,
  [FilterTypeEnum.TIME_RANGE_TYPES]: [],
  [FilterTypeEnum.LIMIT]: 0,
  [FilterTypeEnum.PRICE]: [null, null],
  [FilterTypeEnum.DISCOUNT]: 0,
  [FilterTypeEnum.RATING]: 0,
}

export const HOME_PAGE_FILTER_LAYOUT_TYPE_LIST = [FilterTypeEnum.DATE, FilterTypeEnum.LIMIT]

export const DEFAULT_FILTER_MAX_COUNT = 100
export const DEFAULT_MAX_HEADCOUNT = 20

export const FILTER_TIME_RANGE_TYPE_INFO_MAP = {
  [FilterTimeRangeTypesEnum.MIDNIGHT]: {
    dataTextI18n: 'filter.date.early_morning',
    dateTimeTextI18n: 'filter.date.early_morning_time',
  },
  [FilterTimeRangeTypesEnum.MORNING]: {
    dataTextI18n: 'filter.date.morning',
    dateTimeTextI18n: 'filter.date.morning_time',
  },
  [FilterTimeRangeTypesEnum.NOON]: {
    dataTextI18n: 'filter.date.noon',
    dateTimeTextI18n: 'filter.date.noon_time',
  },
  [FilterTimeRangeTypesEnum.AFTERNOON]: {
    dataTextI18n: 'filter.date.afternoon',
    dateTimeTextI18n: 'filter.date.afternoon_time',
  },
  [FilterTimeRangeTypesEnum.NIGHT]: {
    dataTextI18n: 'filter.date.night',
    dateTimeTextI18n: 'filter.date.night_time',
  },
}
